import { Link, Outlet } from "react-router-dom"

import { FIXED_ASSETS } from "@dl/declarations"
import { LlamaCorp } from "@dl/ui/components/icons"
import { Navbar } from "../navigation/Navbar"
import { LayoutWrapper } from "./LayoutWrapper"

const AuthLayout: React.FC = () => {
    return (
        <LayoutWrapper
            isDarkMode={true}
        >
            <main className="min-h-screen dark">
                <div className="middle">
                    <Navbar isOpenable={false} />

                    <div className='auth-content'>

                        <img
                            alt="Logo"
                            src={FIXED_ASSETS.LLAMA_DESK}
                            className="w-lg aspect-2.25/1 object-cover border-[0.5px] rounded-[15px] my-[50px]"
                        />

                        <Outlet />

                        <p className="inline-flex items-center">
                            <span>A part of </span>
                            <Link
                                to="https://llama-corp.com/"
                                target="_blank"
                                aria-label="LlamaCorp"
                            >
                                <LlamaCorp width={100} height={12} />
                            </Link>
                        </p>
                    </div>
                </div>
            </main>
        </LayoutWrapper>
    )
}

export default AuthLayout